module.exports = __webpack_public_path__ + "img/logo.05cb6489.svg";